export function fuzzyScore(value, query) {
    const text = String(value ?? "").toLowerCase();
    const normalizedQuery = query.trim().toLowerCase();
    if (!text || !normalizedQuery) {
        return normalizedQuery ? null : 0;
    }

    const exactIndex = text.indexOf(normalizedQuery);
    if (exactIndex >= 0) {
        return 1000 - exactIndex * 5 - (text.length - normalizedQuery.length);
    }

    let score = 0;
    let queryIndex = 0;
    let previousMatch = -2;
    let firstMatch = -1;

    for (let textIndex = 0; textIndex < text.length && queryIndex < normalizedQuery.length; textIndex++) {
        if (text[textIndex] !== normalizedQuery[queryIndex]) {
            continue;
        }

        if (firstMatch < 0) {
            firstMatch = textIndex;
        }
        score += textIndex === previousMatch + 1 ? 12 : 3;
        if (textIndex === 0 || /[\s\-_./]/.test(text[textIndex - 1])) {
            score += 8;
        }
        previousMatch = textIndex;
        queryIndex++;
    }

    if (queryIndex !== normalizedQuery.length) {
        return null;
    }

    const span = previousMatch - firstMatch + 1;
    const gapCount = span - normalizedQuery.length;
    if (gapCount > Math.max(4, normalizedQuery.length * 2)) {
        return null;
    }

    return score - firstMatch * 2 - gapCount * 3 - Math.floor((text.length - span) / 4);
}

export function fuzzyFilter(items, query, fields) {
    return items
        .map((item, index) => ({
            item,
            index,
            score: Math.max(...fields.map(([getValue, penalty = 0]) =>
                (fuzzyScore(getValue(item), query) ?? -Infinity) - penalty))
        }))
        .filter(result => result.score > -Infinity)
        .sort((left, right) => right.score - left.score || left.index - right.index)
        .map(result => result.item);
}
